/* Extras del carrito: al marcar/desmarcar una casilla se añade/quita el producto y se repinta el carrito lateral */
document.addEventListener('change', function (e) {
  var t = e.target && e.target.closest ? e.target.closest('[data-ps-extra-toggle]') : null;
  if (!t) return;
  var id = parseInt(t.getAttribute('data-variant-id'), 10);
  var drawer = document.querySelector('cart-drawer');
  var secciones = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
  var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  t.disabled = true;
  var cab = { 'Content-Type': 'application/json', Accept: 'application/json' };
  var peticion = t.checked
    ? fetch(raiz + 'cart/add.js', { method: 'POST', headers: cab, body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: secciones }) })
    : fetch(raiz + 'cart/change.js', { method: 'POST', headers: cab, body: JSON.stringify({ id: String(id), quantity: 0, sections: secciones }) });
  peticion.then(function (r) { return r.json(); }).then(function (estado) {
    if (drawer && estado.sections) { drawer.classList.toggle('is-empty', estado.item_count === 0); drawer.renderContents({ id: null, sections: estado.sections }); }
    else { window.location.reload(); }
  }).catch(function () { t.checked = !t.checked; t.disabled = false; });
});
